<template>
    <!-- <v-dialog v-model="dialog" persistent width="1500px">
    <template v-slot:activator="{ props }">
      <v-btn color="primary" variant="outlined" class="ml-3" v-bind="props" flat>
        <v-icon class="mr-2">mdi-filter</v-icon>Advance Filter
      </v-btn>
    </template> -->
    <v-card style="margin: 0px; padding: 0px" class="mt-5">
        <!-- <v-toolbar dark color="primary">
        <v-toolbar-title>Add Filter</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon="mdi-close" @click="dialog = false"></v-btn>
      </v-toolbar> -->
        <v-card-item style="margin: 0px; padding: 0px">
            <hr style="background-color: gray" />
            <v-row v-for="(item, key) in listFilters" :key="key" class="mt-5">
                <v-col cols="12" :lg="listFilters[key].filterFields == 'expired' ? 5 : 3">
                    <v-select
                        hide-details
                        dense
                        outlined
                        v-model="listFilters[key].model"
                        :items="advanceFilterFields"
                        item-title="label"
                        item-value="model"
                        label="Search"
                        @update:model-value="filterChange(key)"
                        clearable
                    ></v-select>
                </v-col>
                <template v-if="listFilters[key].filterFields == 'date'">
                    <v-col cols="12" lg="3">
                        <BsDateField
                            hide-details
                            clearable
                            dense
                            outlined
                            label="Period From"
                            v-model="listFilters[key].wilcard"
                        ></BsDateField>
                    </v-col>
                    <v-col cols="12" lg="5">
                        <BsDateField
                            hide-details
                            clearable
                            dense
                            outlined
                            label="Period To"
                            v-model="listFilters[key].value"
                        ></BsDateField>
                    </v-col>
                </template>
                <template v-else>
                    <v-col
                        cols="12"
                        lg="3"
                        v-if="listFilters[key].filterFields != 'expired' && listFilters[key].filterFields != 'nationality'"
                    >
                        <v-select
                            hide-details
                            clearable
                            dense
                            outlined
                            :items="listFilters[key].wildCardsList"
                            v-model="listFilters[key].wilcard"
                            label="Search By"
                        ></v-select>
                    </v-col>
                    <v-col
                        cols="12"
                        lg="5"
                        v-if="listFilters[key].filterFields != 'expired' && listFilters[key].filterFields != 'nationality'"
                    >
                        <v-text-field hide-details clearable dense outlined v-model="listFilters[key].value" label="Keyword"></v-text-field>
                    </v-col>
                    <v-col cols="12" lg="6" v-if="listFilters[key].filterFields == 'expired'">
                        <v-select
                            hide-details
                            dense
                            outlined
                            v-model="listFilters[key].value"
                            :items="['On Contract', 'Expired']"
                            item-title="label"
                            item-value="model"
                            label="Select"
                            @update:model-value="filterChange(key)"
                            clearable
                        ></v-select>
                    </v-col>
                    <v-col cols="12" lg="6" v-if="listFilters[key].filterFields == 'nationality'">
                        <v-select
                            hide-details
                            dense
                            outlined
                            v-model="listFilters[key].value"
                            :items="nationalities"
                            item-title="name"
                            item-value="id"
                            label="Select"
                            @update:model-value="filterChange(key)"
                            clearable
                        ></v-select>
                    </v-col>
                </template>
                <v-col cols="12" lg="1">
                    <v-btn dense block color="error" @click="removeFilter(key)" class="mt-2"><v-icon>mdi-trash-can-outline</v-icon></v-btn>
                </v-col>
            </v-row>

            <v-row>
                <v-col cols="6">
                    <v-btn class="float-left" size="default" color="error" variant="flat" @click="closefilters">Cancel</v-btn>
                </v-col>
                <v-col cols="6">
                    <v-btn class="float-right" size="default" color="primary" variant="flat" @click="applyfilters()">Apply</v-btn>
                    <v-btn class="float-right mr-4" size="default" color="info" variant="flat" @click="addFilter()">Add filter</v-btn>
                </v-col>
            </v-row>
            <hr style="background-color: gray" class="mt-5" />
        </v-card-item>
    </v-card>
    <!-- </v-dialog> -->
</template>
<script>
export default {
    data() {
        return {
            listFilters: [],
            nationalities: [],
            wildCardsWord: [
                'Contains',
                'Contains All Words',
                'Starts With',
                'Does Not Start With',
                'Ends With',
                'Does Not End With',
                'Does Not Contain'
            ],
            wildCardNumber: [
                'Is Empty (NULL)',
                'Is Not Rmpty (NULL)',
                'Is Less Than',
                'Is less Than or Equal To',
                'Is Equal To',
                'Is Not equal To',
                'Is Greater Than',
                'Is Between',
                'Is Not Between'
            ],
            advanceFilterFields: [
                // { label: 'Employee ID', model: 'er.employee_id', type: 'text' },
                // { label: 'Name', model: 'er.firstname', type: 'text' },
                // { label: 'Location', model: 'l.name', type: 'text' },
                // { label: 'Department', model: 'd.type', type: 'text' },
                // { label: 'Nationality', model: 'er.nationality', type: 'nationality' },
                // { label: 'Sub Contractor', model: 'sc.name', type: 'text' },
                // { label: 'Position', model: 'p.name', type: 'text' },
                // { label: 'Status', model: 'es.name', type: 'text' },
                // { label: 'Contract', model: 'expired', type: 'expired' },
                // { label: 'Date of Birth', model: 'er.date_of_birth', type: 'date' },
                // { label: 'Date Hired', model: 'ee.date_hired_from', type: 'date' },
                // { label: 'Period', model: 'dtr.record_time', type: 'date' },
            ],
            filter: new this.$Form({
                advanceFilter: []
            }),
            filterstatus: false
        };
    },
    methods: {
        removeFilter(index) {
            if (index > -1) {
                this.listFilters.splice(index, 1);
            }
        },
        filterChange(key) {
            const filter = this.advanceFilterFields.filter((item) => item.model == this.listFilters[key].model);
            this.listFilters[key].filterFields = filter[0].type;

            this.wildCards = [];
            if (filter[0].type == 'text') {
                this.listFilters[key].wildCardsList = this.wildCardsWord;
            } else if (filter[0].type == 'number') {
                this.listFilters[key].wildCardsList = this.wildCardNumber;
            }
        },
        addFilter() {
            this.listFilters.push({
                model: '',
                wilcard: '',
                value: '',
                wildCardsList: []
            });
        },
        applyfilters() {
            this.filter.advanceFilter = this.listFilters;

            this.$emit('applyadfilter', this.filter);
            // this.closefilters(false)
        },
        closefilters() {
            this.filterstatus = false;
            this.$emit('closeadvancefilter', this.filterstatus);
        },
        async getallnationalities() {
            await this.$axios
                .get(`${this.$baseUrlApi}/getallnationalities`)
                .then((data) => {
                    this.nationalities = data;
                })
                .catch((error) => {});
        }
    },
    async created() {
        this.addFilter();
        this.getallnationalities();
    },
    watch: {},
    mounted() {}
};
</script>
